// extracted by mini-css-extract-plugin
export default {"main":"PetWalker_main__YunNh","formDiv":"PetWalker_formDiv__coSac","form":"PetWalker_form__fTpLe","input":"PetWalker_input__VhEE9","select":"PetWalker_select__sJsUO"};